import { Prize } from '@/model/prize';

export class UserPrize {
    public id: string;
    public collectionDate!: Date;
    public bookingDate: Date;
    public prize: Prize;
    public redeemed: boolean;

    constructor(id: string, prize: Prize, bookingDate: Date) {
        this.id = id;
        this.prize = prize;
        this.bookingDate = bookingDate;
        this.redeemed = false;
    }
}
